<template>
  <a v-if="typeArr[0] === 'primary'" class="ssui-btn" :class="classes" @click="disabled ? $emit('btn-click-disabled') : $emit('btn-click')" href="javascript:;">
    <loading-icon class="btn-loading" :loading="loading" :loading-finished="loadingFinished"></loading-icon>
    <slot>{{ text }}</slot>
  </a>
  <div v-else-if="typeArr[0] === 'bottom'" class="ssui-btn" :class="classes">
    <div v-if="typeArr[1] === 'layout1'">
      <div v-if="hasLeft" class="ssui-btn-bottom__left"><slot name="button-left"></slot></div>
      <div class="ssui-btn-bottom__right">
        <slot name="button-tips"></slot>
        <a class="ssui-btn-bottom__btn" @click="disabled ? $emit('btn-click-disabled') : $emit('btn-click')" href="javascript:;">
          <div class="ssui-btn-bottom__main"><slot>{{ text }}</slot></div>
          <div v-if="subText" class="ssui-btn-bottom__sub">{{ subText }}</div>
        </a>
      </div>
    </div>
    <div v-else-if="typeArr[1] === 'layout2'">
      <a v-if="hasLeft" class="ssui-btn-bottom__left" @click="disabledLeft ? $emit('btn-click-left-disabled') : $emit('btn-click-left')" href="javascript:;">{{ textLeft }}</a>
      <a class="ssui-btn-bottom__right" @click="disabledRight ? $emit('btn-click-right-disabled') : $emit('btn-click-right')" href="javascript:;">{{ textRight }}</a>
    </div>
    <template v-else-if="typeArr[1] === 'layout3'">
      <a v-if="hasLeft" class="ssui-btn-bottom__left" @click="disabledLeft ? $emit('btn-click-left-disabled') : $emit('btn-click-left')" href="javascript:;">{{ textLeft }}</a>
      <a class="ssui-btn-bottom__right" @click="disabledRight ? $emit('btn-click-right-disabled') : $emit('btn-click-right')" href="javascript:;">{{ textRight }}</a>
    </template>
  </div>
  <a v-else-if="typeArr[0] === 'small'" class="ssui-btn" :class="classes" @click="disabled ? $emit('btn-click-disabled') : $emit('btn-click')" href="javascript:;">
    <slot>{{ text }}</slot>
  </a>
</template>

<script>
import LoadingIcon from '../loading/icon';

export default {
  components: {
    LoadingIcon,
  },
  props: {
    type: {
      type: String,
      // 冒号前面有三种选择：primary、bottom、small
      default: 'primary:main'
    },
    text: {
      type: String,
      default: '按钮',
    },
    subText: String,
    textLeft: {
      type: String,
      default: '按钮1',
    },
    textRight: {
      type: String,
      default: '按钮2',
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingFinished: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledLeft: {
      type: Boolean,
      default: false
    },
    disabledRight: {
      type: Boolean,
      default: false
    },
    finished: {
      type: Boolean,
      default: false
    },
    // 这里只有finishedRight，是因为finishedRight状态只有layout2中右边按钮会有，左边会在finished状态后隐藏，但保留两个按钮区分的可能性，所以命名finishedRight
    finishedRight: {
      type: Boolean,
      default: false
    },
    hasLeft: {
      type: Boolean,
      default: true
    },
    // 是否是圆角，仅在primary:main生效
    round: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    classes() {
      return [
        `ssui-btn-${this.typeArr[0]}`,
        `ssui-btn-${this.typeArr[0]}_${this.typeArr[1]}`,
        { 'ssui-btn_disabled': this.disabled },
        { 'ssui-btn_loading': this.loading },
        { 'ssui-btn_finished': this.finished },

        { 'btn-round': this.round && this.type === 'primary:main' },

        { 'ssui-btn-bottom_has-sub': this.subText && this.typeArr[0] === 'bottom' },
        { 'ssui-btn_disabled-left': this.disabledLeft && this.typeArr[0] === 'bottom' },
        { 'ssui-btn_disabled-right': this.disabledRight && this.typeArr[0] === 'bottom' },
        { 'ssui-btn_finished-right': this.finishedRight && this.typeArr[0] === 'bottom' },

        { 'ssui-btn-bottom_has-left': this.hasLeft && this.typeArr[1] && this.typeArr[1].indexOf('layout') > -1 },
      ]
    },
    typeArr() {
      return this.type.split(':')
    },
  },
}
</script>
<style lang="less" scoped>
.btn-loading {
  margin-right: 8px;
}
.btn-round {
  border-radius: 22px;
}
</style>




// WEBPACK FOOTER //
// index.vue?709c4b38